import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex gap-12 column justify-start"
}
const _hoisted_2 = {
  key: 1,
  class: "k-pos-button__take-order_container rounded-20 bg-white shadow-1 q-py-20 q-px-xl full-height flex flex-center",
  hoverless: ""
}
const _hoisted_3 = { class: "flex column flex-center gap-12" }
const _hoisted_4 = { class: "fw-500 fs-17px text-dark-bg-20 text-no-wrap" }
const _hoisted_5 = {
  key: 2,
  class: "k-pos-button__active-order absolute"
}
const _hoisted_6 = {
  key: 3,
  class: "k-pos-button__coming-soon flex flex-center text-center absolute"
}

import KGlassCard from './KGlassCard.vue'

interface IProps {
  title: string
  icon: string
  iconColor?: string
  badgeCount?: number
  badge?: string
  epos?: boolean
  isComingSoon?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KPosButton' },
  __name: 'KPosButton',
  props: {
    title: {},
    icon: {},
    iconColor: { default: 'cool-gray-100' },
    badgeCount: { default: 0 },
    badge: { default: '' },
    epos: { type: Boolean, default: false },
    isComingSoon: { type: Boolean, default: false }
  },
  emits: ['action'],
  setup(__props: any) {







return (_ctx: any,_cache: any) => {
  const _component_KIcon = _resolveComponent("KIcon")!
  const _component_KBadge = _resolveComponent("KBadge")!

  return (_openBlock(), _createElementBlock("div", {
    class: "k-pos-button relative-position",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('action')))
  }, [
    _createVNode(KGlassCard, {
      class: _normalizeClass(["shadow-2 glass-card-width rounded-24 full-height", { 'take-order': __props.epos }])
    }, {
      default: _withCtx(() => [
        (!__props.epos)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_KIcon, {
                name: __props.icon,
                size: "32px",
                color: __props.isComingSoon ? 'cool-gray-70' : __props.iconColor
              }, null, 8 /* PROPS */, ["name", "color"]),
              _createElementVNode("span", {
                class: _normalizeClass(["fw-500 fs-17px", [__props.isComingSoon ? 'text-cool-gray-70' : 'text-cool-gray-100']])
              }, _toDisplayString(__props.title), 3 /* TEXT, CLASS */)
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Take Orders "),
        (__props.epos)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "icon"),
                _createElementVNode("span", _hoisted_4, _toDisplayString(__props.title), 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Active Orders "),
        (__props.badge)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_KBadge, {
                label: __props.badge,
                variant: __props.badgeCount,
                "variant-inner-icon": "×",
                "border-color": "lime-100",
                color: "lime-20",
                "label-class": "fs-13px fw-50 text-cool-gray-100",
                hoverless: ""
              }, null, 8 /* PROPS */, ["label", "variant"])
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Coming Soon "),
        (__props.isComingSoon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("span", { class: "k-pos-button__coming-soon--text fs-11px fw-500 text-white q-px-12" }, " Coming Soon ", -1 /* CACHED */)
            ]))]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["class"])
  ]))
}
}

})